import { useState, useEffect } from 'react';
import useApp from './AppContext';
import { useLocation, Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { filterAllByRole } from './crud/utils';

function SideBarMenu(props) {
    const app = useApp();
    const [userid] = useState(app.sessionToken?.UserId);
    const [role] = useState(app.sessionToken?.Role);
    const [mainMenu, setMainMenu] = useState([])
    const [expandedOptions, setExpandedOptions] = useState([]);
    const [isSidebarPinned, setIsSidebarPinned] = useState(() => {
        return sessionStorage.getItem("sidebarPinned") === "true";
    });
    const location = useLocation();

    useEffect(() => {
        async function getMainMenu() {
            if (!role) return;
            if (!props?.options) return;
            const userMenu = filterAllByRole(props?.options, role);
            if (userMenu) {
                setMainMenu(userMenu);
            }
        }
        getMainMenu();
    }, [role, props.options])

    useEffect(() => {
        const sidebar = document.getElementById('sidebar');
        if (sidebar) {
            sidebar.style.width = isSidebarPinned && '350px';

            const style = document.createElement('style');
            style.innerHTML = `
            #sidebar:hover {
                width: ${isSidebarPinned && '350px'} !important;
            }
        `;
            document.head.appendChild(style);
        }
    }, [isSidebarPinned]);

    if (!props.options) return null;
    let link = "/";
    function onItemClick(e, option) {
        e.preventDefault();
        let tmpExpandedOptions = [...expandedOptions];
        if (tmpExpandedOptions.includes(option) && isSidebarPinned) {
            tmpExpandedOptions = tmpExpandedOptions.filter(o => o !== option);
            document.getElementById('sidebar').style.width = (isSidebarPinned && '350px');
        } else if (tmpExpandedOptions.includes(option)) {
            tmpExpandedOptions = tmpExpandedOptions.filter(o => o !== option);
            document.getElementById('sidebar').style.width = '75px';
        } else if (isSidebarPinned) {
            tmpExpandedOptions.push(option);
            document.getElementById('sidebar').style.width = (isSidebarPinned && '350px');
        } else {
            tmpExpandedOptions.push(option);
            document.getElementById('sidebar').style.width = "105px";
        }
        setExpandedOptions(tmpExpandedOptions);
    }
    function createLink(option, i) {
        if (option.link) link = option.link;
        let iconClass = "bi bi-file-earmark-arrow-up";

        if (typeof option["iconclass"] !== 'undefined' && option.iconclass !== '') {
            iconClass = option.iconclass;
        }

        if (option.caption === "My menu") iconClass = "bi bi-menu-up";
        const isExpanded = expandedOptions.includes(option);

        if (option.options) {
            let className = "dropdown-toggle";
            if (isExpanded) className += " expanded";

            return (
                <>
                    {isSidebarPinned || props.isSidebarHovered ? (
                        <a key={'li' + i} href={link} onClick={(e) => onItemClick(e, option)} data-toggle="collapse" aria-expanded={isExpanded} className={`${className} hover-effect`}>
                            <i className={`${iconClass} me-2`}></i>
                            {option.caption}
                        </a>
                    ) : (
                        <a href={link} className={'hover-effect'}>
                            <i className={`${iconClass} d-flex align-items-center justify-content-center`}></i>
                        </a>
                    )}
                </>
            );
        } else {
            const isActive = isActivePath(link);
            let className = isActive ? "active-menu-item" : "";

            return (
                <>
                    {isSidebarPinned || props.isSidebarHovered ? (
                        <Link className={`${className} hover-effect`} key={'li' + i} to={link}>
                            <i className={`${iconClass} me-2`}></i>
                            {(isSidebarPinned || props.isSidebarHovered) && option.caption}
                        </Link>
                    ) : (
                        <Link className={`${className} hover-effect`} key={'li' + i} to={link}>
                            <i className={`${iconClass} d-flex align-items-center justify-content-center`}></i>
                            {props.isSidebarHovered && option.caption}
                        </Link>
                    )}
                </>
            );
        }
    }
    function createListItem(option, i) {
        let subOptions = null;
        if (option.options) {
            subOptions = option.options.map((o, j) => createListItem(o, i.toString() + j));
            let className = "list-unstyled";
            if (expandedOptions.includes(option)) className += " show";
            subOptions = <ul key={'ul' + i} className={className}>{subOptions}</ul>;
        }
        return <li key={option.caption}>
            {createLink(option, i)}
            {subOptions}
        </li>;
    }

    function isActivePath(optionLink) {
        return location.pathname === optionLink;
    }

    if (userid === null || userid === undefined || userid === '') return;
    if (!role) return;
    if (mainMenu.length === 0) return;
    return (
        <>

            {(isSidebarPinned || props.isSidebarHovered) && <div className="pin-sidebar">
                <button
                    className="btn btn-link text-decoration-none"
                    onClick={() => {
                        const sidebar = document.getElementById('sidebar');
                        if (!sidebar) return;

                        const newPinnedValue = !isSidebarPinned;
                        setIsSidebarPinned(newPinnedValue);
                        sessionStorage.setItem("sidebarPinned", newPinnedValue.toString());

                        sidebar.style.width = newPinnedValue ? '350px' : '75px';


                        const style = document.createElement('style');
                        style.innerHTML = `
                                #sidebar:hover {
                                width: ${isSidebarPinned && "350px"} !important;
                                }
                            `;
                        document.head.appendChild(style);
                    }}
                    title={isSidebarPinned ? "Unpin Sidebar" : "Pin Sidebar"}
                >
                    <i className={`bi ${isSidebarPinned ? "bi-pin-angle-fill" : "bi-pin-angle"} fs-5`}></i>
                </button>
            </div>}
            <ul className={`list-unstyled ${app.theme === 'dark' ? 'DarkThemeFont' : ''}`}>
                {mainMenu.map((o, i) => createListItem(o, i))}
            </ul>
        </>



    );
}

export default SideBarMenu;
